import { jwtDecode } from 'jwt-decode';
import type { Token } from '.';

const ENG_SUPPORT_ROLE = 'techsupportsenior';

interface ImpersonatorRolesClaim {
  impersonator_user_roles?: unknown;
}

const rolesFrom = (jwt?: string): unknown[] => {
  if (!jwt) return [];
  try {
    const { impersonator_user_roles: roles } = jwtDecode<ImpersonatorRolesClaim>(jwt);
    return Array.isArray(roles) ? roles : [roles];
  } catch {
    return [];
  }
};

// core-auth 2.11.0 — CVAccessToken is an opaque phantom token, so the roles are read from the CVIdToken JWT first.
// During impersonation `role` belongs to the customer; the staff member's roles arrive in impersonator_user_roles.
export const hasEngSupportRole = (token: Token | null): boolean =>
  [...rolesFrom(token?.cvIdToken), ...rolesFrom(token?.cvAccessToken)].some(
    role => typeof role === 'string' && role.toLowerCase() === ENG_SUPPORT_ROLE
  );
